import { Component } from './component';

export interface GroupBoxProps {
  label?: string;
}

export class GroupBox extends Component {
  public el: HTMLElement;

  constructor(props: GroupBoxProps) {
    super();
    this.el = document.createElement('fieldset');

    if (props.label) {
      const legend = document.createElement('legend');
      legend.appendChild(document.createTextNode(props.label));
      this.el.appendChild(legend);
    }
  }
}
